import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';
import { createPortal } from 'react-dom';
import { useLang } from '../context/LanguageContext';

const GALLERY_IMAGES = [
  {
    src: '/img/photo_2026-03-14_14-36-10.jpg',
    alt_ru: 'Ресторанная зона',
    alt_es: 'Zona de restaurante',
    size: 'large',
  },
  {
    src: '/img/photo_3_2026-03-14_14-38-32.jpg',
    alt_ru: 'Детский парк развлечений',
    alt_es: 'Parque infantil',
    size: 'small',
  },
  {
    src: '/img/photo_21_2026-03-14_14-37-22.jpg',
    alt_ru: 'Организация мероприятий',
    alt_es: 'Organización de eventos',
    size: 'small',
  },
  {
    src: '/img/photo_20_2026-03-14_14-37-22.jpg',
    alt_ru: 'Атмосфера праздника',
    alt_es: 'Atmósfera de fiesta',
    size: 'large',
  },
  {
    src: '/img/7P3A6815.jpg',
    alt_ru: 'Интерьер event-пространства',
    alt_es: 'Interior del espacio de eventos',
    size: 'small',
  },
  {
    src: '/img/20251114_182400.jpg',
    alt_ru: 'Детский праздник',
    alt_es: 'Fiesta infantil',
    size: 'large',
  },
  {
    src: '/img/20260115_125422.jpg',
    alt_ru: 'Развлечения для детей',
    alt_es: 'Entretenimiento para niños',
    size: 'small',
  },
  {
    src: '/img/IMG_5085.JPG',
    alt_ru: 'Event-зона KidsMafia',
    alt_es: 'Zona de eventos KidsMafia',
    size: 'small',
  },
  {
    src: '/img/IMG_5118.JPG',
    alt_ru: 'Семейное мероприятие',
    alt_es: 'Evento familiar',
    size: 'small',
  },
  {
    src: '/img/photo_10_2026-03-14_14-41-40.jpg',
    alt_ru: 'Банкетная зона',
    alt_es: 'Zona de banquetes',
    size: 'large',
  },
  {
    src: '/img/photo_8_2026-03-14_14-41-40.jpg',
    alt_ru: 'Оформление праздников',
    alt_es: 'Decoración de fiestas',
    size: 'small',
  },
  {
    src: '/img/7P3A6847.jpg',
    alt_ru: 'Праздничное оформление',
    alt_es: 'Decoración festiva',
    size: 'small',
  },
  {
    src: '/img/7P3A6853.jpg',
    alt_ru: 'Детская развлекательная зона',
    alt_es: 'Zona de entretenimiento infantil',
    size: 'large',
  },
  {
    src: '/img/7P3A6890.jpg',
    alt_ru: 'Игровая активность',
    alt_es: 'Actividad de juego',
    size: 'small',
  },
  {
    src: '/img/7P3A7105.jpg',
    alt_ru: 'День рождения в KidsMafia',
    alt_es: 'Cumpleaños en KidsMafia',
    size: 'small',
  },
  {
    src: '/img/20251114_182452.jpg',
    alt_ru: 'Детский праздник',
    alt_es: 'Fiesta de niños',
    size: 'large',
  },
  {
    src: '/img/20251206_194341.jpg',
    alt_ru: 'Интерактивные активности',
    alt_es: 'Actividades interactivas',
    size: 'small',
  },
  {
    src: '/img/20260115_125443.jpg',
    alt_ru: 'Детское мероприятие',
    alt_es: 'Evento infantil',
    size: 'large',
  },
  {
    src: '/img/20260115_125454.jpg',
    alt_ru: 'Игры и развлечения',
    alt_es: 'Juegos y entretenimiento',
    size: 'small',
  },
  {
    src: '/img/20260115_125507.jpg',
    alt_ru: 'Креативные активности',
    alt_es: 'Actividades creativas',
    size: 'small',
  },
  {
    src: '/img/20260115_125528.jpg',
    alt_ru: 'Зона отдыха',
    alt_es: 'Zona de descanso',
    size: 'large',
  },
  {
    src: '/img/20260115_125759.jpg',
    alt_ru: 'Детское пространство',
    alt_es: 'Espacio infantil',
    size: 'small',
  },
  {
    src: '/img/IMG_5169.JPG',
    alt_ru: 'Организация праздников',
    alt_es: 'Organización de fiestas',
    size: 'small',
  },
  {
    src: '/img/IMG_5185.JPG',
    alt_ru: 'Event-площадка',
    alt_es: 'Plataforma de eventos',
    size: 'small',
  },
  {
    src: '/img/IMG_5191.JPG',
    alt_ru: 'Семейный досуг',
    alt_es: 'Ocio familiar',
    size: 'large',
  },
  {
    src: '/img/IMG_5200.JPG',
    alt_ru: 'Атмосфера веселья',
    alt_es: 'Atmósfera de diversión',
    size: 'small',
  },
  {
    src: '/img/20250913_200318.jpg',
    alt_ru: 'Праздничное пространство',
    alt_es: 'Espacio festivo',
    size: 'large',
  },
  {
    src: '/img/IMG_2802.JPG',
    alt_ru: 'KidsMafia event-центр',
    alt_es: 'Centro de eventos KidsMafia',
    size: 'small',
  },
  {
    src: '/img/IMG_5751.JPG',
    alt_ru: 'Детская игровая площадка',
    alt_es: 'Área de juegos infantil',
    size: 'large',
  },
  {
    src: '/img/IMG_5772.JPG',
    alt_ru: 'Развлекательный центр',
    alt_es: 'Centro de entretenimiento',
    size: 'small',
  },
];

function Lightbox({ images, index, lang, onClose, onPrev, onNext }) {
  return createPortal(
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[200] flex items-center justify-center"
        style={{ background: 'rgba(0,0,0,0.96)', backdropFilter: 'blur(20px)' }}
        onClick={onClose}
        data-testid="lightbox"
      >
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 w-12 h-12 rounded-full glass flex items-center justify-center text-white hover:bg-white/10 transition-all z-10"
          data-testid="lightbox-close"
        >
          <X size={20} />
        </button>

        {/* Nav prev */}
        <button
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          className="absolute left-4 md:left-8 w-12 h-12 rounded-full glass flex items-center justify-center text-white hover:bg-white/10 transition-all z-10"
          data-testid="lightbox-prev"
        >
          <ChevronLeft size={22} />
        </button>

        {/* Image */}
        <motion.img
          key={index}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
          src={images[index].src}
          alt={lang === 'ru' ? images[index].alt_ru : images[index].alt_es}
          className="max-w-[88vw] max-h-[80vh] object-contain rounded-2xl"
          onClick={(e) => e.stopPropagation()}
        />

        {/* Nav next */}
        <button
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          className="absolute right-4 md:right-8 w-12 h-12 rounded-full glass flex items-center justify-center text-white hover:bg-white/10 transition-all z-10"
          data-testid="lightbox-next"
        >
          <ChevronRight size={22} />
        </button>

        {/* Counter */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
          {images.map((_, i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full transition-all"
              style={{ background: i === index ? '#D4AF37' : 'rgba(255,255,255,0.3)' }}
            />
          ))}
        </div>

        {/* Caption */}
        <p className="absolute bottom-14 left-1/2 -translate-x-1/2 text-[#BFC3C9] text-sm text-center">
          {lang === 'ru' ? images[index].alt_ru : images[index].alt_es}
        </p>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
}

export default function Gallery() {
  const { t, lang } = useLang();
  const gal = t.gallery;
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const openLightbox = (i) => setLightboxIndex(i);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () => setLightboxIndex((prev) => (prev - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length);
  const nextImage = () => setLightboxIndex((prev) => (prev + 1) % GALLERY_IMAGES.length);

  return (
    <section id="gallery" className="py-24 md:py-32 relative overflow-hidden" style={{ background: '#12141A' }}>
      <div
        className="orb-gold absolute"
        style={{ width: 500, height: 500, top: '0', left: '50%', transform: 'translateX(-50%)', opacity: 0.05 }}
      />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-px bg-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs uppercase tracking-widest font-semibold">Gallery</span>
          </div>
          <h2 
            className="text-4xl md:text-6xl font-black text-white mb-4 font-heading"
            style={{
              fontFamily: "'Sora', sans-serif",
              textShadow: '0 2px 30px rgba(0,0,0,0.5)'
            }}
          >
            {gal.title}
          </h2>
          <p className="text-[#BFC3C9] text-lg">{gal.subtitle}</p>
        </motion.div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {GALLERY_IMAGES.map((image, idx) => {
            const isLarge = image.size === 'large';
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: (idx % 6) * 0.1 }}
                className={`gallery-img relative rounded-2xl overflow-hidden cursor-pointer group ${
                  isLarge ? 'md:row-span-2' : ''
                }`}
                style={{ height: isLarge ? 500 : 240 }}
                onClick={() => openLightbox(idx)}
                data-testid={`gallery-image-${idx}`}
              >
                <img
                  src={image.src}
                  alt={lang === 'ru' ? image.alt_ru : image.alt_es}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-4">
                  <span className="text-white font-medium text-sm">
                    {lang === 'ru' ? image.alt_ru : image.alt_es}
                  </span>
                  <div className="w-9 h-9 rounded-full bg-[#D4AF37]/20 backdrop-blur-sm flex items-center justify-center">
                    <ZoomIn size={16} className="text-[#D4AF37]" />
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <Lightbox
          images={GALLERY_IMAGES}
          index={lightboxIndex}
          lang={lang}
          onClose={closeLightbox}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </section>
  );
}
